import { render, staticRenderFns } from "./StepHeader.vue?vue&type=template&id=2633710c&scoped=true"
import script from "./StepHeader.vue?vue&type=script&lang=ts"
export * from "./StepHeader.vue?vue&type=script&lang=ts"
import style0 from "./StepHeader.vue?vue&type=style&index=0&id=2633710c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2633710c",
  null
  
)

export default component.exports